"use strict";

$(document).ready(function () {
  $(document).on('click', '.submit-a-request', function (e) {
    e.preventDefault();
    $('.request-form-holder').addClass('show');
    $('.request-form-holder').fadeIn(300);
    $('.request-form input[name="request-form-link"]').val($('.product_link').attr('content'));
  });
  $(document).on('click', '.request-form-close', function (e) {
    $('.request-form-holder').removeClass('show');
    setTimeout(function () {
      $('.request-form-holder').fadeOut(300);
      $('.request-form input[name="request-form-link"]').val('');
    }, 300);
  });
  $(document).on('focus', '.request-form input', function (e) {
    $(this).parents('.form-group').removeClass('field-error');
  });
  $(document).on('click', '.btn-add-to-cart', function () {
    $('body').addClass('modal-visible');

    if ($(window).width() > 1050) {
      var element = $('.desktop-header-wrapper .blockcart.cart-preview')[0];
      var elWidth = $('.desktop-header-wrapper .blockcart.cart-preview').width();
      var elHeight = $('.desktop-header-wrapper .blockcart.cart-preview').height();
    } else if ($(window).width() <= 1050) {
      var element = $('.mobile-header-wrapper .blockcart.cart-preview')[0];
      var elWidth = $('.mobile-header-wrapper .blockcart.cart-preview').width();
      var elHeight = $('.mobile-header-wrapper .blockcart.cart-preview').height();
    }

    var topPos = element.getBoundingClientRect().top + window.scrollY;
    var leftPos = element.getBoundingClientRect().left + window.scrollX;
    setTimeout(function () {
      if ($('.blockcart-modal[aria-labelledby=blockcart-modal-label]').attr('aria-hidden') === 'true') {
        $('.blockcart-modal[aria-labelledby=blockcart-modal-label]').removeAttr('aria-hidden');
        $('.blockcart-modal[aria-labelledby=blockcart-modal-label]').attr("aria-modal", "true");
        $('.blockcart-modal[aria-labelledby=blockcart-modal-label]').css('display', 'block');
        $('.blockcart-modal[aria-labelledby=blockcart-modal-label]').addClass('show');
        window.scrollTo(0, 0);
      }

      var modalWid = $('.blockcart-modal[aria-labelledby=blockcart-modal-label]').width();

      if ($(window).width() > 1050) {
        var styles = {
          top: topPos + elHeight + 'px',
          left: leftPos + elWidth - (modalWid + 25) + 'px'
        };
      } else if ($(window).width() <= 1050) {
        var styles = {
          top: topPos + elHeight + 'px',
          left: 'unset'
        };
      }

      $('.blockcart-modal[aria-labelledby=blockcart-modal-label]').css(styles);
      $('.blockcart.cart-preview').find('a.cart').addClass('active');
    }, 1000);
  });
  $(document).on('click', '.blockcart-modal[aria-labelledby=blockcart-modal-label] .close', function () {
    $('body').removeClass('modal-visible');
    setTimeout(function () {
      if ($('.blockcart-modal[aria-labelledby=blockcart-modal-label]').attr('aria-hidden') !== 'true') {
        $('.blockcart-modal[aria-labelledby=blockcart-modal-label]').attr('aria-hidden', 'aria-hidden');
        $('.blockcart-modal[aria-labelledby=blockcart-modal-label]').removeAttr("aria-modal");
        $('.blockcart-modal[aria-labelledby=blockcart-modal-label]').removeAttr('style');
        $('.blockcart-modal[aria-labelledby=blockcart-modal-label]').removeClass('show');
        $('.modal-backdrop').remove();
      }
    }, 500);
  });
});
$(window).on('resize', function () {
  if ($('.blockcart-modal[aria-labelledby=blockcart-modal-label]').length > 0) {
    if ($(window).width() > 1050) {
      var element = $('.desktop-header-wrapper .blockcart.cart-preview')[0];
      var elWidth = $('.desktop-header-wrapper .blockcart.cart-preview').width();
      var elHeight = $('.desktop-header-wrapper .blockcart.cart-preview').height();
      var padding_right = 25;
    } else if ($(window).width() <= 1050) {
      var element = $('.mobile-header-wrapper .blockcart.cart-preview')[0];
      var elWidth = $('.mobile-header-wrapper .blockcart.cart-preview').width();
      var elHeight = $('.mobile-header-wrapper .blockcart.cart-preview').height();
      var padding_right = 10;
    } else if ($(window).width() <= 576) {
      var padding_right = 10;
    }

    var topPos = element.getBoundingClientRect().top + window.scrollY;
    var leftPos = element.getBoundingClientRect().left + window.scrollX;
    var modalWid = $('.blockcart-modal[aria-labelledby=blockcart-modal-label]').width();

    if ($(window).width() > 1050) {
      var styles = {
        top: topPos + elHeight + 'px',
        left: leftPos + elWidth - (modalWid + padding_right) + 'px'
      };
    } else {
      var styles = {
        top: topPos + elHeight + 'px',
        left: 'unset'
      };
    }

    $('.blockcart-modal[aria-labelledby=blockcart-modal-label]').css(styles);
  }
});